import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { SessionContext } from '../contexts/SessionContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireValidation: boolean;
  requireGeoValidation: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireValidation, 
  requireGeoValidation 
}) => {
  const { validated, geoValidated } = useContext(SessionContext);

  if (requireValidation && !validated) {
    return <Navigate to="/" replace />;
  }

  if (requireGeoValidation && !geoValidated) {
    return <Navigate to="/geo-validation" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
